import { environment } from 'environments/environment';

export interface IStateDetails {
    title: string;
    description: string;
    color: string;
    icon: string;
}

export const GRAY_COLOR: string = '#5C5B5B';
export const YELLOW_COLOR: string = '#E39906';
export const GREEN_COLOR: string = '#00A917';
export const RED_COLOR: string = '#ED1C24';
export const BLUE_COLOR: string = '#1577D5';

export const stateDetails: { [key: number]: IStateDetails } = {
    '0': {
        title: 'Aún sin procesar',
        description: 'El pedido requiere la aprobación manual de un operador',
        color: GRAY_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/0.png'
    },
    '1': {
        title: 'Cancelado',
        description: 'El pedido fue cerrado sin éxito. Esto puede deberse a que tú lo cancelaste o se agotó el tiempo de espera.',
        color: RED_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/1.png'
    },
    '3': {
        title: 'Omitido',
        description:
            'El pedido fue descartado. Esto puede deberse a que has excedido los límites de operación o tienes otro pedido en curso.',
        color: GRAY_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/2.png'
    },
    '5': {
        title: 'En preparación',
        description: 'El pedido requiere la aprobación manual de un operador.',
        color: YELLOW_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/5.png'
    },
    '6': {
        title: 'En preparación',
        description: 'El pedido está listo y el sistema se encuentra buscando destinos.',
        color: YELLOW_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/6.png'
    },
    '9': {
        title: 'Pausado',
        description: 'Uno de los pagos enviados o recibidos aún no ha llegado a destino.',
        color: GRAY_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/9.png'
    },
    '10': {
        title: 'Pausado',
        description: 'Uno de nuestros operadores se encuentra trabajando en el pedido.',
        color: GRAY_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/10.png'
    },
    '11': {
        title: 'Esperando tu pago',
        description: 'Las instrucciones fueron generadas: debes realizar los pagos y marcar “Ya lo envié”.',
        color: BLUE_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/11.png'
    },
    '12': {
        title: 'Enviando',
        description: 'El pedido está en cola de pagos: recibirás el total de tu saldo en una o varias partes.',
        color: YELLOW_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/12.png'
    },
    '13': {
        title: 'Validación requerida',
        description:
            'Por motivos de seguridad, se ha solicitado documentación que respalde el pedido. Entre ellas documento de identidad, selfie u otras.',
        color: BLUE_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/13.png'
    },
    '14': {
        title: 'Validación requerida',
        description:
            'Por motivos de seguridad, se ha solicitado documentación que respalde el pedido. Entre ellas documento de identidad, selfie u otras.',
        color: BLUE_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/14.png'
    },
    '15': {
        title: 'Validación requerida',
        description:
            'Por motivos de seguridad, se ha solicitado documentación que respalde el pedido. Entre ellas documento de identidad, selfie u otras.',
        color: BLUE_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/15.png'
    },
    '16': {
        title: 'Validación requerida',
        description:
            'Por motivos de seguridad, se ha solicitado documentación que respalde el pedido. Entre ellas documento de identidad, selfie u otras.',
        color: BLUE_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/16.png'
    },
    '20': {
        title: 'Enviado',
        description: '¡Listo! El pedido ha sido completado exitosamente.',
        color: GREEN_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/20.png'
    },
    '21': {
        title: 'Enviando',
        description: 'El envío está casi listo, sólo quedan algunos detalles.',
        color: GREEN_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/21.png'
    },
    '22': {
        title: 'Enviado',
        description: '¡Listo! El pedido ha sido completado exitosamente.',
        color: GREEN_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/22.png'
    },
    '23': {
        title: 'Envío reprogramado',
        description:
            'El pago será enviado en un pedido siguiente. Esto se debe a que se unificaron los pagos o has solicitado cambiar tu cuenta de destino.',
        color: GREEN_COLOR,
        icon: environment.LEGACYURL + 'img/states-public/22.png'
    }
};
